// import SellerBoxIcon from '@/assets/icons/SellerBoxIcon.svg?react';
import { GA_ROUTES } from '@/constants/ga';
import { SignupForm } from '@/containers/auth/signup-form';
import { usePageView } from '@/hooks/use-page-view';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * TODO 라우팅 할지 조건부 렌더링할지 고민하기.... 체크박스 표시
 */
const SignUpPage = () => {
  const navigate = useNavigate();

  usePageView(GA_ROUTES.signup);

  return (
    <div className="flex h-[100vh] flex-col items-center overflow-y-auto bg-gr-50 pt-[clamp(80px,20vh,272px)] max-md:bg-white max-md:pt-10">
      <div className="space-y-5 max-md:w-full">
        <button className="flex items-center gap-3 max-md:px-5" onClick={() => navigate(-1)}>
          <ChevronLeftIcon className="h-8 w-8 max-md:h-6 max-md:w-6" />
          <div className="text-gr-900 Title2S24 max-md:Body1S16">회원가입</div>
        </button>
        <SignupForm />
      </div>
    </div>
  );
};

export default SignUpPage;
